<template>
    <div>
        <div class="objectStorageMonitor-title">
            <div>{{ $t('alarms.objectStorage.objectStorage') }}</div>
        </div>
        <template>
            <Tabs size="small" :animated="false">
                <TabPane :label="$t('alarms.objectStorage.objectStorage')">
                    <div class="objectStorageMonitor-top">
                        <object-storage-search></object-storage-search>
                    </div>
                    <table-object-storage></table-object-storage>
                </TabPane>
            </Tabs>
        </template>
        
    </div>
</template>

<script>
    import ObjectStorageSearch from '../object_storage/ObjectStorageSearch'
    import TableObjectStorage from '../object_storage/TableObjectStorage'

    export default {
        name: 'ObjectStorageMonitor',
        components: {
            ObjectStorageSearch,
            TableObjectStorage
        }
    }
</script>

<style scoped>
    .objectStorageMonitor-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
        overflow: hidden;
    }
    .objectStorageMonitor-title>div:nth-child(1)
    {
        float:left;
    }
    .objectStorageMonitor-top
    {
        width: 100%;
        height: 32px;
        margin-bottom: 14px;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/object_storage/ObjectStorageMonitor.vue